import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { setCurrentFolderId, unsetCurrentFolderId } from '../actions';
import { getCurrentGallection, getCurrentFolderId } from '../selectors';
export const useCurrentGallection = ()=>_object_spread({}, useMMSelector((state)=>({
            currentFolderId: getCurrentFolderId(state),
            currentGallection: getCurrentGallection(state)
        })), useMMDispatchActions({
        setCurrentFolderId,
        unsetCurrentFolderId
    }));
export default ((component)=>connectMediaStore((state)=>({
            currentFolderId: getCurrentFolderId(state),
            currentGallection: getCurrentGallection(state)
        }), {
        setCurrentFolderId,
        unsetCurrentFolderId
    })(component)); // redux typings are a bit dumb with generics
